export default __webpack_public_path__ + "static/media/jnvu.ba5c22fd.jpg";